import { useState } from "react";

type DataModal = {
  activeModal: string | null;
  activeModalData: unknown | null;
  activeModalErrors?: unknown | null;
};

export type onToggleDataModalFn = (values: unknown, name: string) => void;

const useDataModal = (): {
  data: DataModal;
  onToggle: onToggleDataModalFn;
} => {
  const [data, setData] = useState<DataModal>({
    activeModal: null,
    activeModalData: null,
    activeModalErrors: null
  });

  const toggleModal = (values: unknown, name: string) => {
    setData({
      activeModal: name,
      activeModalData: values
    });
  };

  return { data, onToggle: toggleModal };
};

export default useDataModal;
